import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { proGroupsQueryOptions } from "api/queries/proGroups";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { location?: ForManagerLocationDetail };

export const allGroupsQuery = ({ location }: QueriesInput) =>
  proGroupsQueryOptions(
    { organization_id: location?.organization_id, market_id: location?.market_id },
    { enabled: location != null },
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [allGroupsQuery(input)];
